import { useCallback } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { Submit, ButtonContainer } from 'libs/ui';
import { StyledField, required, ErrorMsg } from 'libs/form';

const ContactFormForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, error, submitting } = props;
  const rightUpdate = user.haveRight('clients.update');

  const requiredField = useCallback(required(t), [t]);

  return (
    <form onSubmit={handleSubmit}>
      <ErrorMsg theme="dark" message={error} />

      <StyledField validate={requiredField} type="text" label={t('form.ФИО')} name="name" placeholder={t('form.Иванов Иван Иванович')} />
      <StyledField validate={requiredField} type="text" label={t('grid.Телефон')} name="tel_num" placeholder={t('grid.+7 (999) 999-99-99')} />
      <StyledField type="text" label={t('grid.Доп.телефон')} name="tel_num_2" placeholder={t('grid.+7 (999) 999-99-99')} />
      <StyledField type="text" label={t('form.E-mail')} name="email" placeholder={t('form.E-mail')} />
      <StyledField type="text" label={t('form.Доп. email')} name="email_2" placeholder={t('form.E-mail')} />
      <StyledField type="text" label={t('form.Веб-сайт')} name="website" placeholder={t('form.Веб-сайт')} />
      <StyledField type="text" label={t('form.Адрес')} name="address" placeholder="г. Санкт-Петербург, Загородный проспект 26, кв 43" />
      {rightUpdate && (
        <ButtonContainer>
          <Submit disabled={submitting} />
        </ButtonContainer>
      )}
    </form>
  );
};

export const ContactForm = reduxForm({
  form: 'contactForm',
})(ContactFormForm);
